function getClassName(component, suffix) {
  return `ui-${component}-${suffix}`;
}
export {
  getClassName as g
};
//# sourceMappingURL=classNames.DrrTR-Hz.mjs.map
